// Safe wrapper around GA4 gtag.js (loaded in index.html).
// No-ops gracefully if gtag isn't available (e.g. content blockers) and never throws,
// mirroring the defensive style of metaPixel.js.
export function trackGa4Event(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // analytics must never break the user experience
  }
}

export function trackGa4Lead(value, source) {
  const params = { lead_source: source, currency: 'GBP' };
  if (typeof value === 'number' && Number.isFinite(value)) {
    params.value = value;
  }
  trackGa4Event('generate_lead', params);
}

export function trackGa4Purchase(value, transactionId) {
  const params = { currency: 'GBP' };
  if (typeof value === 'number' && Number.isFinite(value)) {
    params.value = value;
  }
  if (transactionId) {
    params.transaction_id = String(transactionId);
  }
  trackGa4Event('purchase', params);
}

// Fires the Google Ads conversion (AW-17106266789) and, for enhanced conversions,
// passes the lead's email/phone (Google hashes them). Safe no-op if gtag isn't loaded.
export function trackAdsConversion({ email, phone } = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      if (email || phone) {
        window.gtag('set', 'user_data', {
          email: email || undefined,
          phone_number: phone || undefined,
        });
      }
      window.gtag('event', 'conversion', { send_to: 'AW-17106266789/TNq9CImY698cEKXV89w_' });
    }
  } catch (e) {
    // analytics must never break the user experience
  }
}